import * as React from 'react'

import {
  ResourceTemplate,
  useResolvedTemplate,
} from '~/client/src/shared/components/FormListSelector'

interface IUseChosenTemplateGateParams {
  isCreationMode: boolean
  templates: ResourceTemplate[]
  loading: boolean
}

interface IUseChosenTemplateGateResult {
  chosenTemplateId: string | null
  setChosenTemplateId: (id: string | null) => void
  needsSelection: boolean
  effectiveTemplateId: string | null
  effectiveTemplate: ResourceTemplate | null
  isEmpty: boolean
  templates: ResourceTemplate[]
}

export function useChosenTemplateGate({
  isCreationMode,
  templates,
  loading,
}: IUseChosenTemplateGateParams): IUseChosenTemplateGateResult {
  const [chosenTemplateId, setChosenTemplateId] = React.useState<string | null>(
    null,
  )

  if (!isCreationMode && chosenTemplateId !== null) {
    setChosenTemplateId(null)
  }

  const {
    needsSelection,
    effectiveTemplateId,
    effectiveTemplate,
    templates: resolvedTemplates,
    isEmpty,
  } = useResolvedTemplate({
    enabled: isCreationMode,
    chosenTemplateId,
    templates,
    loading,
  })

  return {
    chosenTemplateId,
    setChosenTemplateId,
    needsSelection,
    effectiveTemplateId,
    effectiveTemplate,
    isEmpty,
    templates: resolvedTemplates,
  }
}
